var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series[0].data.length > 0)?_c('apex-chart',{attrs:{"type":"bar","width":"100%","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }